import { RouterLink } from "../../../../../components/router-link";

interface Props {
  messageId: string;
  label: string;
}

export const MessageDetailLinkCell = ({ messageId, label }: Props) => {
  return (
    <RouterLink params={{ messageId }} to={"/app/messages/$messageId"} underline="hover">
      {label}
    </RouterLink>
  );
};
